export default new URLSearchParams(window.location.search);